import { Component, inject, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormField, MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { MatOption } from '@angular/material/core';
import { MatIcon } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

@Component({
  selector: 'app-invite-user-dialog',
  templateUrl: './users-dialog.component.html',
  styleUrl: './users-dialog.component.css',
  standalone: true,
  imports: [FormsModule, MatFormField, MatOption, MatIcon, MatLabel, MatFormField, MatFormFieldModule, MatDialogActions, MatDialogContent, CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule]
})
export class UsersDialogComponent {

  private fb = inject(FormBuilder);
  private dialogRef = inject(MatDialogRef<UsersDialogComponent>);

  form = this.fb.group({
    email: ['', [Validators.required, Validators.email]],
    full_name: ['', Validators.required],
    role: ['', Validators.required],
    tenant_id: ['']
  });

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      isPlatformAdmin: boolean;
      tenantOptions?: string[];
      currentTenantId?: string;
    }
  ) {

    if (!data.isPlatformAdmin) {
      this.form.patchValue({ tenant_id: data.currentTenantId });
    }
  }

  submit() {
    if (this.form.invalid) return;
    this.dialogRef.close(this.form.value);
  }

  cancel() {
    this.dialogRef.close();
  }
}
